import { render, staticRenderFns } from "./IncomeAndExpenditure.vue?vue&type=template&id=036cee28&scoped=true&"
import script from "./IncomeAndExpenditure.vue?vue&type=script&lang=js&"
export * from "./IncomeAndExpenditure.vue?vue&type=script&lang=js&"
import style0 from "./IncomeAndExpenditure.vue?vue&type=style&index=0&id=036cee28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036cee28",
  null
  
)

export default component.exports